export default {
  'Acesse a plataforma da FacilitaPay': { en: 'Sign in to the FacilitaPay Platform' },
  'Ação': { en: 'Action' },
  'Adicionar': {en: 'Add'},
  'Adicionar novo endereço IP': {en: 'Add new IP address'},
  'Adicionar Canal Bancário': { en: 'Adding Bank Account' },
  'Agência': { en: 'Branch' },
  'Aguardando': { en: 'Waiting for' },
  'Aguardando confirmação': { en: 'Waiting confirmation', es: 'Esperando confirmacion' },
  'Aguardando correção': { en: 'Waiting for correction', es: 'Esperando corrección' },
  'Aguardando nova tentativa': { en: 'Waiting for retry', es: 'Esperando reintentar' },
  'Aguardando há': { en: 'Waiting for' },
  'Aguardando pela identificação do transferência de entrada': { en: 'Waiting for identifying incoming transfer' },
  'Aguarde enquanto o Pix é validado. Este processo pode levar até 1 minuto.': { en: 'Please wait while the Pix payment is validated. This process can take up to one minute.' },
  'Ainda não tem conta? Crie agora!': { en: "Don't have an account yet? Create one now!" },
  'Algo errado. Não foi possível autenticar': {en: 'Something went wrong'},
  'Algo errado. Não foi possível carregar as operações.': { en: 'Something is wrong. Unable to load operations.' },
  'Algo errado. Não foi possível carregar as transações.': { en: 'Something is wrong. Unable to load transactions.' },
  'Algo errado. Não foi possível carregar as transferências.': { en: 'Something is wrong. Unable to load wires.' },
  'Algo errado. Não foi possível carregar os': { en: 'Something is wrong. Unable to load the' },
  'Algo errado. Não foi possível verificar o link.': { en: 'Something wrong. Unable to verify link.' },
  'Ano de criação': { en: 'Creation year' },
  'A senha não pode começar ou terminar com espaços em branco': {en: 'Password cannot start or end with blank spaces'},
  'A senha não pode conter o caractere Ç ou ç': {en: 'Password cannot contain the character Ç or ç'},
  'Ao fornecer o código de compartilhamento a terceiros, estes poderão realizar transações': { en: 'By sharing this code, others can access your registration data' },
  'FX automático': {en: 'Auto FX' },
  'aprovação': { en: 'approval' },
  'Aprovado há': { en: 'Approved for' },
  'Aprovado Nivel 1': { en: 'Approved Level 1' },
  'Aprovado Nivel 2': { en: 'Approved Level 2' },
  'Aprovado por': { en: 'Approved by' },
  'Aprovados': { en: 'Approved' },
  'Aprovando': { en: 'Approving' },
  'Aprovar Cadastro': { en: 'Approve Registration' },
  'Aprovar': { en: 'Approve' },
  'Arquivos maiores que 14.9Mb não podem ser enviados': { en: 'Files larger than 14.9Mb are not allowed' },
  'As contas não foram configuradas corretamente. Contate o suporte.': { en: 'Accounts were not properly configured. Contact support.'},
  'Associação': { en: 'Association' },
  'Atenção': { en: 'Attention' },
  'Ativar usuário': { en: 'Activate user' },
  'Atividade': { en: 'Activity' },
  'Atividade Principal': { en: 'Main activity' },
  'Ativo': { en: 'Active' },
  'Atualizar/Aprovar': { en: 'Update/Approve' },
  'Atualizar Cadastro': { en: 'Update Registration' },
  'Atualizar Canal Bancário': { en: 'Updating Bank Account' },
  'Atualizar': { en: 'Update' },
  'Autenticação de Dois Fatores': { en: 'Two Factor Authentication' },
  'Autorização': { en: 'Authorization' },
  'Arquivo': { en: 'File' },
  'arquivos': { en: 'files' },
  'Bairro': { en: 'Neighborhood' },
  'Baixar': { en: 'Download' },
  'Baixar recibo': { en: 'Download receipt', es: 'Descargar recibo' },
  'Baixar %s': { en: 'Download %s' },
  'Baixe o aplicativo': { en: 'Download the app' },
  'Bancária': { en: 'Bank' },
  'Banco': { en: 'Bank' },
  'Beneficiário': { en: 'Receiver', es: 'Recipiente' },
  'Brasil': { en: 'Brazil' },
  'Brasileira': { en: 'Brazilian', es: 'Brasileña' },
  'Brasileiro': { en: 'Brazilian?' },
  'Busca': { en: 'Search' },
  'Buscando cadastros': { en: 'Searching for customers' },
  'Buscar Cadastro': { en: 'Search Customer' },
  'Buscar Cadastros': { en: 'Search Customers' },
  'Buscar': { en: 'Search' },
  'Buscar por': { en: 'Search by', es: 'Buscar por' },
  'Cadastrando conta beneficiária': { en: 'Registering the recipient account' },
  'Cadastrando o cliente': { en: 'Registering the customer' },
  'Cadastrar/Aprovar': { en: 'Register/Approve' },
  'Cadastrar': { en: 'Register' },
  'Cadastrar outra conta': { en: 'Register another account' },
  'Cadastrar Outra Referência': { en: 'Register Another Reference' },
  'Cadastrar Outro Sócio': { en: 'Register Another Partner' },
  'Cadastrar-se': { en: 'Sign Up' },
  'Cadastrar Sócio': { en: 'Register Partner' },
  'Cadastro em processamento': { en: 'Waiting for approval' },
  'Cadastro': { en: 'Registration' },
  'cadastros aguardando aprovação': { en: 'pending approval registrations' },
  'Cadastros aguardando aprovação': { en: 'Pending approval registrations' },
  'Cadastros Aprovados': { en: 'Approved Customers' },
  'cadastros aprovados': { en: 'approved registrations' },
  'Cadastros aprovados': { en: 'Approved registrations' },
  'Cadastros': { en: 'Customers' },
  'Cadastros em Análise': { en: 'Pending KYC' },
  'Cadastros Reprovados': { en: 'Reproved Customers' },
  'cadastros reprovados': { en: 'reproved registrations' },
  'Cadastros reprovados': { en: 'Reproved registrations' },
  'Câmbio': { en: 'Rate' },
  'CÂMBIO': { en: 'RATE' },
  'Campo obrigatório': {en: 'Required field'},
  'Canais bancários': { en: 'Bank accounts' },
  'Canais Bancários': { en: 'Bank Accounts' },
  'Canal Bancário Destino': { en: 'Destiny Bank Account' },
  'Canal Bancário Origem': { en: 'Origin Bank Account' },
  'Cancelada': { en: 'Canceled' },
  'Cancelar': { en: 'Cancel' },
  'Cancelar Token': { en: 'Cancel Token' },
  'Cancelar transação': { en: 'Cancel transaction' },
  'Capital aberto': { en: 'Open capital' },
  'Carregando arquivo... aguarde': { en: 'Uploading file... wait' },
  'Carregando': { en: 'Loading' },
  'Carregando operações...': { en: 'Loading operations...' },
  'Carregando transações...': { en: 'Loading transactions...' },
  'Carregando transferências...': { en: 'Loading wires...' },
  'CEP': { en: 'Zipcode' },
  'Cheque seu email e acesse utilizando o link enviado': { en: 'Check your mailbox and click on the reset password link' },
  'Chilena': { en: 'Chilean' },
  'Cidade': { en: 'City' },
  'Cliente beneficiado': { en: 'Recipient customer' },
  'Cliente': { en: 'Customer' },
  'Cliente envia %s para conta interna %s do parceiro': { en: 'Customer deposits %s to %s internal partner account' },
  'Cliente envia %s para conta %s do parceiro': { en: 'Customer deposits %s to %s partner account' },
  'Cliente pagador': { en: 'Payer customer' },
  'Clique aqui e cadastre os dados da sua conta corrente': { en: 'Click here and register your bank account details' },
  'Clique aqui para visualizar o código de compartilhamento': { en: 'Click here to show the account sharing code' },
  'Cobrar do cliente': { en: 'Charge customer' },
  'Cobrar %s para conta %s': { en: 'Charge %s to %s account' },
  'Código Banco': { en: 'Bank Code' },
  'Código': { en: 'Code' },
  'Código Swift do Banco': { en: 'Bank Swift Code' },
  'Colombiana': { en: 'Colombian' },
  'Colômbia': { en: 'Colombia' },
  'Chile': { en: 'Chile' },
  'Comercial': { en: 'Commercial' },
  'Como usar o Google Authenticator para Autenticação de Dois Fatores': { en: 'How to use Google Authenticator for Two Factor Authentication' },
  'Compartilhar conta': { en: 'Share account' },
  'Compartilhar': { en: 'Share account' },
  'Complemento': { en: 'Complement' },
  'Compra': { en: "Purchase" },
  'Comprovante de residência não enviado': { en: 'Proof of address missing' },
  'Comprovante de residência rejeitado': { en: 'Proof of address rejected' },
  'Confirmada': { en: 'Confirmed', es: 'Confirmada' },
  'Confirmar': { en: 'Confirm' },
  'Confirmar transação': { en: 'Transaction confirmation' },
  'Confirmação da senha não confere': {en: 'Password confirmation does not match'},
  '*CONSIDERANDO CÂMBIO': { en: '*CONSIDERING RATE' },
  'Conta Bancária': { en: 'Bank Account' },
  'Conta Corrente': { en: 'Checking account' },
  'Conta de origem ': { en: 'Source bank account ', es: 'Cuenta bancaria de origen' },
  'Conta destino': { en: 'Destination bank account', es: 'Cuenta bancaria de destino' },
  'Conta do beneficiário': { en: 'Recipient bank account' },
  'Conta': { en: 'Account', es: 'Cuenta' },
  'Conta interna': { en: 'Internal account' },
  'Conta para débito': { en: 'Bank Account for debit' },
  'Conta para TED': { en: 'Bank Account for TED' },
  'Conta para Wire': { en: 'Bank Account for Wire' },
  'Contas de Taxas Operacionais': { en: 'Fee accounts' },
  'Contas Bancárias da FacilitaPay usadas para receber os pagamentos dos clientes': { en: 'FacilitaPay Bank Accounts used for collections' },
  'Contas FacilitaPay para pagamentos': { en: 'FacilitaPay pay-in accounts' },
  'Contas Internas FacilitaPay': { en: 'FacilitaPay Internal Accounts' },
  'Conta tipo': { en: 'Account type' },
  'Contêm a soma das taxas referentes às operações já feitas': { en: 'Contains the sum of the applied fees on all processed transactions' },
  'Controle': { en: 'Control', es: 'Control' },
  'Conversão entre contas internas': { en: 'Exchange between internal accounts' },
  'Converter para': { en: 'Exchange to' },
  'Converter %s de conta interna %s': { en: 'Exchange %s internal to %s' },
  'Convertida': { en: 'Exchanged' },
  'convertido de': { en: 'exchanged from' },
  'convertido para': { en: 'exchanged for' },
  'convertidos para': { en: 'converted to' },
  'Créditos (transações/total)': { en: 'Credits (transactions/total)' },
  'Criar/Aprovar': { en: 'Create/Approve' },
  'Criar Cadastro': { en: 'Register Customer' },
  'Criar Token': { en: 'Create Token' },
  'Criar Transação': { en: 'Create transaction' },
  'Criar Usuário': { en: 'Create User' },
  'Data da transferência: ': { en: 'Wire date: ', es: 'Fecha de alambre: ' },
  'Data de constituição': { en: 'Creation Date' },
  'Data de nascimento': { en: 'Birthdate' },
  'DATA': { en: 'DATE' },
  'Data inicial': { en: 'Start date', es: 'Fecha de inicio' },
  'Data final': { en: 'End date', es: 'Fecha final' },
  'Data': { en: 'Date', es: 'Fecha' },
  'Debitado': {en: 'Debited'},
  'Débitos (transações/total)': { en: 'Debits (transactions/total)' },
  'De': { en: 'From', es: 'De' },
  'Defina a sua senha nos campos abaixo': { en: 'Enter your new password in the fields below' },
  'Definir opção "FX automático" para todas as transações de câmbio': { en: 'Set "Auto FX" option for all transactions exchange' },
  'Definir opção "FX sob demanda" para todas as transações de câmbio': { en: 'Set "FX on demand" option for all transactions exchange' },
  'Definir o valor final': { en: 'Set the final value' },
  'Definir Senha': { en: 'Set password' },
  '% de Participação*': { en: 'Partnership percentage' },
  'Depositar %s para conta interna %s': { en: 'Deposit %s to %s account' },
  'Depósito em conta interna': { en: 'Deposit to internal account' },
  'Desabilitar usuário': { en: 'Disable user' },
  'Desabilitar Usuário': { en: 'Disable User' },
  'Desativar usuário': { en: 'Deactivate user' },
  'Descrição': { en: 'Description' },
  'Destinatário': { en: 'Receiver' },
  'DESTINO': { en: 'DESTINATION' },
  'DETALHES DA TRANSAÇÃO': { en: 'TRANSACTION DETAILS' },
  'DETALHES': { en: 'DETAILS' },
  'Detalhes': { en: 'Details' },
  'Digite o código de 6 dígitos do seu aplicativo Google Authenticator': { en: 'Enter 6-digit code from your Google Authenticator APP' },
  'Digite um e-mail válido': { en: 'Enter a valid e-mail address' },
  'Documento (CNPJ)*': { en: 'CNPJ Number*' },
  'Documento (CPF)*': { en: 'CPF Number*' },
  'Documento': { en: 'Document' },
  'Documento não enviado': { en: 'Photo id missing' },
  'Documento rejeitado': { en: 'Photo id rejected' },
  'Documentos': { en: 'Documents' },
  'Domicílio Fiscal': { en: 'Tax Domicile' },
  'Download de recibo de pagamento': { en: 'Wire receipt download', es: 'Descargar recibo de alambre' },
  'é inválido': { en: 'is invalid' },
  'Editar Usuário': { en: 'Edit User' },
  'Email do Usuário': { en: 'User e-mail' },
  'Email e/ou senha Incorretos': {en: 'Email or password incorrect'},
  'Email enviado': { en: 'Email sent' },
  'Em aprovação': { en: 'Pending Approval' },
  'Endereço': { en: 'Address' },
  'Endereços IPs Permitidos': {en: 'Allowed IP addresses'},
  'Endereço IP já adicionado': {en: 'IP address already added'},
  'Endereço Blockchain': { en: 'Blockchain Address' },
  'entrada': { en: 'cash-in' },
  'entrada / saída': { en: 'cash-in / cash-out' },
  'Entrar': { en: 'Log in' },
  'Enviado': { en: 'Sent' },
  'Envio': { en: 'Outgoing' },
  'Enviar arquivo': { en: 'Send file' },
  'Enviar arquivos': { en: 'Send files' },
  'Erro interno. Contate o suporte.': { en: 'Server Error. Contact support.'},
  'É necessário pelo menos um endereço IP': {en: 'At least one IP address is required'},
  'É preciso aguardar a aprovação do seu cadastro antes de realizar operações': { en: 'You must wait for registration approval before creating transactions' },
  'É preciso cadastrar suas informações antes de realizar operações': { en: 'You must register before creating transactions' },
  'Escaneie o QR Code abaixo e clique no botão "Prosseguir" no final desta janela': { en: 'Scan the QR Code below and click on the "Next" button in the botton of this window' },
  'Escaneie o QR Code para efetuar o pagamento ': { en: 'Scan the QR Code below to make the payment' },
  'Escolha o tipo de pessoa': { en: 'Choose a registration type' },
  'Escaneie o QR Code para efetuar o pagamento.': { en: 'Scan the QR Code below to make the payment.'},
  'Esqueci minha senha': { en: "I forgot my password" },
  'Estado': { en: 'State' },
  'Esta operação não poderá ser desfeita': { en: 'This operation cannot be undone' },
  'Exchange reverso': { en: 'Reverse exchange' },
  'Excluindo': { en: 'Deleting' },
  'Excluir': { en: 'Delete' },
  'Excluir registro': { en: 'Delete Record' },
  'Exibir código': { en: 'Display code' },
  'Exibir mais': { en: 'Show more' },
  'Expira em ': { en: 'Expires in' },
  'Extrato': { en: 'Statement' },
  'Extrato Smartbank': { en: 'Smartbank statement' },
  'false': { en: 'False', pt: 'Não' },
  'Falhou': { en: 'Failed', es: 'Fallida' },
  'Faturamento médio mensal': { en: 'Average monthly income' },
  'Favorecido': { en: 'Favored', es: 'Favorecido' },
  'Fazer Cadastro': { en: 'Registration' },
  'Fechar Câmbio': { en: 'Create Exchange' },
  'Fechar': { en: 'Close' },
  'Feriados': { en: 'Holidays' },
  'Filtrar por status': { en: 'Status Filter' },
  'Finalidade: Crédito em Conta': { en: 'Purpose: Bank Transfer', es: 'Propósito: Crédito de la Cuenta' },
  'financeiras em seu nome por meio da FacilitaPay.': { en: 'and request transactions in your behalf.' },
  'Física': { en: 'Person' },
  'Fluxo': { en: 'Flow' },
  'Formato de Endereço IP inválido': {en: 'Invalid IP address format'},
  'Forma de Pagamento': { en: 'Payment Method' },
  'Formato inválido': { en: 'Invalid format'},
  'Fundação': { en: 'Fundation' },
  'Gerenciar Feriados': { en: 'Manage Holidays' },
  'Google Autenticador': { en: 'Google Authenticator' },
  'Habilitar permissão por endereço IP': {en: 'Enable permission by IP address'},
  'Habilitar usuário': { en: 'Enable user' },
  'Habilitar Usuário': { en: 'Enable User' },
  'Há mais de um tipo de documento para pessoas físicas. Escolha um': { en: 'There is more than one type of document for persons. Choose one' },
  'Histórico': { en: 'Historic' },
  'Id cadastro': { en: 'Customer ID' },
  'ID da Transferência': { en: 'Wire ID' },
  'ID Transação/Transferência': { en: 'Transaction/Wire ID' },
  'Identificação': { en: 'Identification' },
  'Identificada': { en: 'Identified' },
  'Id Origem': { en: 'Source Id' },
  'Informe o valor do TED': { en: 'Enter the TED amount' },
  'Informe o valor do Wire': { en: 'Enter the Wire amount' },
  'Informe o Valor': { en: 'Enter the amount' },
  'Informe seu E-mail': { en: 'Enter your E-mail address' },
  'Informe seu Nome e Email': { en: 'Enter your Name and Email' },
  'Integração': { en: 'API Integration' },
  'Internacional': { en: 'International' },
  'ISPB Banco': { en: 'Bank ISPB' },
  'Jurídica': { en: 'Company' },
  'Lembrar-me': { en: "Remember Me"},
  'Ler QR Code': { en: 'Scan QR Code' },
  'Limite excedido. O pagamento será estornado em breve': { en: 'Limit exceeded. The payment will be refunded soon' },
  'Limpar busca': { en: 'Reset search' },
  'Limpar': { en: 'Clean' },
  'Linhas por página': { en: 'Rows per page' },
  'Listar Usuários': { en: 'List Users' },
  'Logradouro': { en: 'Street' },
  'LTDA': { en: 'Private' },
  'Mais Antiga': { en: 'Older' },
  'Mais Antigas': { en: 'Older' },
  'Mais Recente': { en: 'Newer' },
  'Mais Recentes': { en: 'Newer' },
  'Mantenha suas informações atualizadas': { en: 'Keep your registration updated' },
  'Máximo de 64 caracteres': { en: 'Maximum of 64 characters' },
  'Mexicana': { en: 'Mexican' },
  'México': { en: 'Mexico' },
  'Mínimo de 12 caracteres': { en: 'Minimum of 12 characters' },
  'Minhas Contas': { en: 'My Accounts' },
  'Moeda destino': { en: 'Destination currency' },
  'Moeda': { en: 'Currency' },
  'Moeda origem': { en: 'Source currency' },
  'Mostrar QR Code': { en: 'Show QR Code' },
  'Mostrar Texto': { en: 'Show Text' },
  'Motivo Reprovação': { en: 'Reproved Reason' },
  'Nacionalidade': { en: 'Nationality' },
  'Não Ativo': { en: 'Not Active' },
  'Não autorizado': { en: 'Not authorized' },
  'Não': { en: 'No' },
  'Não atualize a página, isso será feito automaticamente após a identificação do pagamento.': { en: 'Do not refresh this page. It will be updated automatically after the payment is received.' },
  'Não existem': { en: 'There are no' },
  'Não existem operações de câmbio neste momento.': { en: 'There are no exchange operations at this time.' },
  'Não existem transações associadas.': { en: 'There are no associated transactions' },
  'As transações associadas foram canceladas.': { en: 'The associated transactions were canceled'},
  'Não foi possível carregar as operações. Você não foi autorizado.': { en: 'Failed to load operations. Access Denied.' },
  'Não foi possível carregar as transações. Você não foi autorizado.': { en: 'Failed to load transactions. Access Denied.' },
  'Não foi possível carregar a transação. Verifique o ID informado.': { en: 'Failed to load the transaction. Check the informed ID.' },
  'Não foi possível carregar as transferências. Você não foi autorizado.': { en: 'Failed to load wires. Access Denied.' },
  'Não foi possível carregar os dados do recibo informado: ': { en: 'Unable to retrieve receipt information: ', es: 'No se puede recuperar datos de recibo' },
  'Não foi possível carregar os': { en: 'Failed to load the' },
  'Não foi possível completar o upload do arquivo': { en: 'Unable to complete upload of the file' },
  'Não pode ser zero': { en: 'Can not be zero' },
  'Natureza': { en: 'Nature' },
  'Nenhuma transação para câmbio neste momento.': { en: 'No transactions available for exchange at this time.' },
  'Nenhuma transação registrada': { en: 'No transaction registered' },
  'Nenhuma transferência registrada': { en: 'No wire registered' },
  'Nenhum cadastro encontrado': { en: 'No customer found' },
  'Nenhum canal bancário registrado': { en: 'No registered bank accounts' },
  'Nenhum usuário registrado': { en: 'No registered users' },
  'Nível atual': { en: 'Current level' },
  'Nível necessário': { en: 'Required level' },
  'Nome Banco': { en: 'Bank Name' },
  'Nome completo': { en: 'Full name' },
  'Nome/Documento': { en: 'Name/Document' },
  'Nome': { en: 'Name' },
  'Nome Fantasia': { en: 'Brand Name' },
  'Nova Conta Bancária': { en: 'New Bank Account' },
  'Nova Transação': { en: 'New Transaction' },
  'Novo Cadastro': { en: 'New Customer' },
  'Novo Cliente': { en: 'New Customer' },
  'Novo': { en: 'New' },
  'Novo Pagamento': { en: 'New Payment' },
  'Novo Usuário': { en: 'New User' },
  'Núm. documento': { en: 'Doc. number', es: 'Núm. documento' },
  'Número da conta': { en: 'Account number' },
  'Número documento': { en: 'Document number' },
  'Número Documento': { en: 'Document Number' },
  'Número': { en: 'Number' },
  'Nº do Doc. Cliente': { en: 'Customer Doc Number' },
  'o aplicativo Google Authenticator': { en: 'the Google Authenticator app' },
  'Obrigatório': { en: 'Mandatory' },
  'Obrigatório código ou ISPB do banco': { en: 'Bank `Code` or ISPB needed' },
  'O código enviado não esta correto, tente novamente.': { en: 'The provided code is not correct, please try again.' },
  'O download do arquivo foi iniciado. Verifique a pasta de downloads!': { en: 'The file download has been requested. Check your Downloads folder!', es: 'La descarga de archivos ha sido solicitada. Revise su carpeta de descargas pronto!' },
  'Operação': { en: 'Operation' },
  'OPERAÇÕES': { en: 'OPERATIONS' },
  'Operações de Câmbio': { en: 'Foreign Exchange Operations' },
  'FX sob demanda': {en: 'FX on demand' },
  'O tempo para se fazer o pagamento esgotou. Por favor, crie um novo código.': {en: 'This QR code has expired. Please generate a new one.' },
  'Origem': { en: 'Origin' },
  'OrigemB': { en: 'Source', pt: 'Origem' },
  'ORIGEM': { en: 'ORIGIN' },
  'O tempo para se fazer o pagamento esgotou. Por favor, crie um novo código.': { en: 'This QR code has expired. Please generate a new one.'},
  'O seu arquivo está pronto para ser baixado. Clique no botão ao lado para fazer o download.': { en: 'Your file is ready to be created. Click on the side button to download.', es: 'Su archivo está listo para ser creado. Haga clic en el botón lateral para descargar.' },
  'Outra': { en: 'Other', es: 'Otra' },
  'Outro': { en: 'Other', es: 'Otro' },
  'Outros': { en: 'Others' },
  'O valor convertido foi enviado': { en: 'Exchanged value has been wired' },
  'Pagador': { en: 'Payer', es: 'Pagador' },
  'Pagamento': { en: 'Payment' },
  'Pagamento de taxas': { en: 'Fee Pay Off' },
  'Pagamento recebido com sucesso': { en: 'Payment has been successfully received' },
  'Pagar cliente': { en: 'Pay customer' },
  'Pagar o cliente': { en: 'Pay customer' },
  'Pagar %s de conta %s': { en: 'Pay %s to %s account' },
  'País de Origem': { en: 'Birth country' },
  'País Domicílio Fiscal': { en: 'Fiscal Country' },
  'País': { en: 'Country' },
  'Pagamento não realizado, tente novamente.': { en: 'Unsuccessful transaction, try again.', ptbr: ''},
  'para conta interna': { en: 'for internal account' },
  'para': { en: 'to' },
  'Para': { en: 'To', es: 'Para' },
  'Para pagar': { en: 'To pay' },
  'Parceiro converte %s de conta interna para %s': { en: 'Partner exchanges %s from internal account to %s' },
  'Parceiro envia %s de conta interna para conta %s do cliente': { en: 'Partner sends %s from internal account to %s customer account' },
  'Parceiro envia %s para conta interna %s': { en: 'Partner deposits %s to internal %s account' },
  'Parceiro envia %s para conta %s do cliente': { en: 'Partner deposits %s to %s customer account' },
  'Parceiro retira de conta interna %s para conta %s': { en: 'Partner withdrawals from internal %s to %s account'},
  'Passaporte': { en: 'Passport' },
  'Patrimônio líquido': { en: 'Net worth' },
  'Pelo menos uma letra maiúscula': { en: 'At least one uppercase letter' },
  'Pelo menos uma letra minúscula': { en: 'At least one lowercase letter' },
  'Pelo menos um número': { en: 'At least one number' },
  'Pelo menos um caractere especial !, @, #, etc.': { en: 'At least one special character !, @, #, etc.' },
  'Pendente': { en: 'Pending' },
  'Permissões': { en: 'Privileges' },
  'Pessoa Física': { en: 'Individual Customer' },
  'Pessoa Jurídica': { en: 'Corporate Customer' },
  'Pessoa tipo': { en: 'Partner kind' },
  'Por favor, confirme antes de avançar': { en: 'Please, review before going forward' },
  'Poupança': { en: 'Savings account' },
  'Procurar': { en: 'Search' },
  'Prosseguir': { en: 'Next' },
  'Provedor de taxa de câmbio': { en: 'Exchange rate provider' },
  'Razão Social': { en: 'Company Name' },
  'Realizar conversão': { en: 'Exchange' },
  'Realizar novas operações e consultar operações': { en: 'Create new exchange operations' },
  'Realizar novas operações e consultar operações': { en: 'List and create transactions' },
  'Realizar Operação de Câmbio': { en: 'Perform Exchange Operation' },
  'Receber de cliente': { en: 'Receive from customer' },
  'Recebido': { en: 'Received' },
  'Recebimento': { en: 'Receivement' },
  'RecebimentoB': { en: 'Incoming', pt: 'Recebimento' },
  'Recibo de Transferência': { en: 'Wire Receipt', es: 'Recibo de Alambre' },
  'Redefinição de senha': { en: 'Password reset' },
  'Referência': { en: 'Reference' },
  'Referências': { en: 'References' },
  'Referência tipo': { en: 'Reference kind' },
  'referente aos 12 meses anteriores': { en: 'last 12 months' },
  'Registrar Cliente': { en: 'Register Customer' },
  'Registrar': { en: 'Register' },
  'Registrar Operação de Câmbio': { en: 'Register Exchange Operation' },
  'Registro': { en: 'Record' },
  'Registros': { en: 'Records' },
  'Regras para nova senha': { en: 'Rules for new password'},
  'Repita senha': {en: 'Repeat Password'},
  'Reprovado há': { en: 'Reproved for' },
  'Reprovados': { en: 'Reproved' },
  'Reprovar Cadastro': { en: 'Reprove Registration' },
  'Reprovar': { en: 'Reprove' },
  'RESETAR': { en: 'RESET' },
  'Resetar senha': { en: 'Reset password' },
  'Retirada de conta interna': { en: 'Withdrawal from internal account' },
  'Sacar %s de conta interna %s': { en: 'Withdraw %s from %s internal account' },
  'S/A': { en: 'S/A' },
  'saída': { en: 'cash-out' },
  'Sair': { en: 'Logout' },
  'Saldo conta interna': { en: 'Internal account balance' },
  'Saldo': { en: 'Balance' },
  'Saldo Total': { en: 'Total balance' },
  'Seja bem vindo': { en: 'Welcome' },
  'Selecione a conta beneficiária': { en: 'Select the recicient bank account' },
  'Selecione a conta': { en: 'Select a bank account' },
  'Selecione a forma de pagamento': { en: 'Select the payment method' },
  'Selecione a moeda da conta': { en: 'Select the bank account currency' },
  'Selecione a operação': { en: 'Select the operation' },
  'Selecione as moedas da operação': { en: 'Choose the operation currencies' },
  'Selecione o cliente': { en: 'Select the customer' },
  'Selecione no máximo': { en: 'Select up to' },
  'Seleção de documento': { en: 'Document type select' },
  'Sem fins lucrativos': { en: 'Not-profit' },
  'Senha': { en: "Password" },
  'Senha deve ter pelo menos 8 caracteres': {en: 'Password must be at least 8 characters'},
  'Senha definida?': { en: "Password set?" },
  'Sessão expirada, redirecionando para o login...': { en: 'Section expired, redirecting to log-in...' },
  'Sim': { en: 'Yes' },
  'Sócio': { en: 'Partner' },
  'Sócios': { en: 'Partners' },
  'Solicitar Câmbio': { en: 'Exchange Request' },
  'Solicitar': { en: 'Request' },
  'SPOT': { en: 'SPOT RATE' },
  'Taxa': { en: 'Fee' },
  'Taxa de câmbio': { en: 'Exchange rate' },
  'Taxa de Câmbio': { en: 'Exchange Rate' },
  'Taxa de câmbio fechada': { en: 'Exchange rate closed' },
  'Taxa de Câmbio FX (com IOF)': { en: 'FX Exchange Rate (with IOF)' },
  'Taxa de Câmbio Spot': { en: 'Spot Exchange Rate' },
  'TAXA DE TRANSAÇÃO': { en: 'TRANSACTION FEE' },
  'Taxa TED enviado': { en: 'TED fee sent' },
  'Taxa TED recebido': { en: 'TED fee received' },
  'TED para conta FacilitaPay': { en: 'TED to BRL FacilitaPay Account' },
  'Telefone': { en: 'Phone' },
  'Telefone': { en: 'Phone number' },
  'Cod. País': { en: 'Country Code' },
  'Cod. Área': {en: 'Area Code'},
  'Tempo limite excedido.': { en: 'Time limit exceeded.'},
  'Tipo de Operação': { en: 'Operation Type' },
  'Tipo Documento': { en: 'Document type' },
  'Tipo documento': { en: 'Document type', es: 'Tipo documento' },
  'Tipo': { en: 'Type' },
  'Todas': { en: 'All' },
  'Total Enviado': { en: 'Balance Sent' },
  'Total movimentado': { en: 'Transaction totals' },
  'Total Recebido': { en: 'Balance Received' },
  'Transação Cancelada': { en: 'Canceled Transaction' },
  'Transação Convertida': { en: 'Exchanged Transaction' },
  'TRANSAÇÃO': { en: 'TRANSACTION' },
  'Transação Identificada': { en: 'Identified Transaction' },
  'Transação Pendente': { en: 'Pending Transaction' },
  'Transação Transferida': { en: 'Wired Transaction' },
  'Transações associadas': { en: 'Related transactions' },
  'Transações Bancárias': { en: 'Bank Transactions' },
  'Transações': { en: 'Transactions' },
  'Transações para Câmbio': { en: 'Transactions for Foreign Exchange' },
  'Transações Programadas': { en: 'Scheduled Bank Transactions' },
  'Transferência de entrada identificada': { en: 'Incoming transfer identified' },
  'TRANSFERÊNCIA': { en: 'WIRE' },
  'Transferência': { en: 'Wire' },
  'Transferência Internacional': { en: 'International Wire' },
  'Transferência Realizada': { en: 'Wire Receipt' },
  'Transferências em Espera': { en: 'Pending Wires' },
  'Transferências': { en: 'Wires' },
  'Transferências Registradas': { en: 'Registered Wires' },
  'Transferida': { en: 'Wired' },
  'true': { en: 'True', pt: 'Sim' },
  'Últimas transações': { en: 'Latest transactions' },
  'Um link para criar nova senha foi enviado para o e-mail inserido, caso ele exista em nosso sistema. Siga as instruções contidas nele para redefinir sua senha.': { en: 'A link has been sent to you e-mail, if it exists in our system. Follow the instructions to reset your password.' },
  'Um link será enviado por email para definir sua senha.': { en: 'A link will be sent by email to set your password' },
  'Um link será enviado por email para redefinir sua senha': { en: 'A link will be sent by email to reset your password' },
  'Usuário': { en: 'User' },
  'Usuários': { en: 'Users' },
  'Usuários Vinculados': { en: 'Registered Users' },
  'Valor a transferir': { en: 'Value to wire' },
  'Valor a receber': { en: 'Amount to receive' },
  'Valor da transação': { en: 'Transaction value' },
  'VALOR': { en: 'VALUE' },
  'VALOR*': { en: 'VALUE*' },
  'Valor': { en: 'Value', es: 'Valor' },
  'VALOR ESTIMADO': { en: 'ESTIMATED VALUE' },
  'Valor FX': { en: 'FX Value' },
  'Valor IOF': { en: 'IOF Value' },
  'Valor moeda estrangeira': { en: 'Foreign currency value' },
  'Valor moeda nacional': { en: 'Local currency value' },
  'Valor recebido': { en: 'Received value' },
  'Valor estimado': { en: 'Estimated value' },
  'Após Taxa': { en: 'After Tax' },
  'Venda': { en: "Sale" },
  'Vender moeda estrangeira': { en: 'Sell foreign currency' },
  'Verificar e aprovar cadastros pendentes': { en: 'Check for pending approval registrations' },
  'Ver QR Code': { en: 'Display QR Code' },
  'Você não foi autorizado': { en: 'You are not authorized' },
  'Você tem certeza': { en: 'Are you sure' },
  'Voltar': { en: 'Back' },
  'Voltar para o login': { en: 'Back to login page' },
  'Wire para conta FacilitaPay': { en: 'Wire to FacilitaPay Account' },
  'Cambio solicitado pelo cliente': {en: 'Exchange requested by the customer' },
  'Cambio Solicitado': { en: 'Exchange requested' },
  'Cambio Reverso': { en: 'Reverse Exchange' },
  'Pix Dinamico': { en: 'Dynamic pix' },
  'Data de vencimento do pix': { en: 'Pix due date' },
  'Resumo da Transação': { en: 'Transaction Summary'},
  'Status': { en: 'Status'},
  'Sucesso': { en: 'Success'},
  'Falha': { en: 'Fail'},
  'Moeda': { en: 'Currency'},
  'Valor': { en: 'Value'},
  'De': { en: 'From'},
  'Para': { en: 'To'},
  'Moeda crypto': { en: 'Crypto Coin'},
  'Limpar cache e recarregar': { en: 'Clear cache and reload' },
  'Pesquise pelo número da conta ou apelido': {en: 'Search by account number or nickname'},
  'Digite pelo menos 3 caracteres e tecle enter': {en: 'Type at least 3 characters and hit enter'},
  'Pesquise pelo número da conta, digite pelo menos 3 caracteres e tecle enter': {en: 'Search by account number, type at least 3 characters and hit enter'},
  'Nenhum registro encontrado': { en: 'No records found'},
  'Pesquisar por ID': {en: 'Search by ID'},
  'Bank transaction associated with transaction': { pt: 'Transação bancária associada a uma transação' },
  'credit card transaction associated with bank transaction': { pt: 'Transação de cartão de crédito associada a transação bancária' },
  "Infractions can only be canceled when their status is delivered or closed": {pt: 'Infrações só podem ser canceladas quando estão com status delivered ou closed'},
  "Infraction with non valid status for analysis": {pt: 'Infração com status inválido para análise'},
  "Chargeback with non valid status for analysis": {pt: 'Chargeback com status inválido para análise'},
  "This infraction can not be canceled because it was not opened by FacilitaPay": {pt: 'Esta infração não pode ser cancelada pois não foi aberta pela FacilitaPay'},
  "Unavailable service": {pt: 'Serviço indisponível'},
  "Chargeback already canceled": {pt: 'O chargeback já foi cancelado'},
  "Chargebacks can only be canceled when their status is delivered": {pt: 'Chargebacks só podem ser cancelados quando estão com status delivered'},
  "Could not find payment by the given company_wire_id": {pt: 'Não foi possível encontrar o pagamento com o company_wire_id fornecido'},
  "connect_timeout": {pt: 'Tempo de conexão expirou'},
  'Infraction already opened': {pt: 'Infração já foi criada'},
  'Invalid facilita bank transaction': {pt: 'Transação bancária facilita invalida'},
  'Chargeback already opened': { pt: 'Chargeback já foi criado' },
  'must be less than or equal to the company_wire value': {pt: 'O valor do chargeback deve ser menor ou igual ao valor da transferência'},
  'Código do Banco': { en: 'Bank Code', es: 'Código Bancario' },
}



// WEBPACK FOOTER //
// ./src/shared/Translations.js